
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AnalyticsInfrastructurePanel from "@/components/admin/AnalyticsInfrastructurePanel";
import CoreValueDashboard from "@/components/admin/CoreValueDashboard";
import CurationTroubleshootingPanel from "@/components/admin/CurationTroubleshootingPanel";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "sonner";

const AdminAnalytics = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("core-value");

  // Check if user is admin
  useEffect(() => {
    const checkAdmin = async () => {
      if (!user) {
        toast.error("Please sign in to access this page");
        navigate("/auth");
        return;
      }

      if (user.email !== "grayholland@ux-flo.com") {
        toast.error("You don't have permission to access this page");
        navigate("/dashboard");
        return;
      }
    };

    checkAdmin();
  }, [user, navigate]);

  if (!user) {
    return (
      <div className="h-full flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin h-10 w-10 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading authentication status...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full overflow-auto bg-background">
      <div className="container mx-auto py-8 px-4">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground">Analytics Dashboard</h1>
          <p className="mt-2 text-muted-foreground">
            Smart tracking, batch processing, and data retention for core value features
          </p>
        </div>
        
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full max-w-lg grid-cols-3 bg-muted">
            <TabsTrigger value="core-value" className="data-[state=active]:bg-background data-[state=active]:text-foreground">
              Core Value Features
            </TabsTrigger>
            <TabsTrigger value="troubleshooting" className="data-[state=active]:bg-background data-[state=active]:text-foreground">
              Curation Debug
            </TabsTrigger>
            <TabsTrigger value="infrastructure" className="data-[state=active]:bg-background data-[state=active]:text-foreground">
              Infrastructure
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="core-value" className="space-y-4">
            <CoreValueDashboard />
          </TabsContent>
          
          <TabsContent value="troubleshooting" className="space-y-4">
            <CurationTroubleshootingPanel />
          </TabsContent>
          
          <TabsContent value="infrastructure" className="space-y-4">
            <AnalyticsInfrastructurePanel />
            
            <div className="mt-8 p-4 bg-yellow-50 dark:bg-yellow-950/20 border border-yellow-200 dark:border-yellow-800 rounded-lg">
              <h3 className="font-semibold text-yellow-800 dark:text-yellow-200 mb-2">Next Phases</h3>
              <ul className="text-sm text-yellow-700 dark:text-yellow-300 space-y-1">
                <li>• Phase 2: User Funnel+ (Visitor → Registered → Users → Active Users)</li>
                <li>• Phase 3: Advanced Insights & Predictive Analytics</li>
              </ul>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};

export default AdminAnalytics;
